import { styled } from 'styled-components';

import { ButtonGroup } from '@src/components/atoms/inputs/button';

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);

  ${ButtonGroup} {
    margin-top: calc(-1 * var(--spacing-4) + var(--spacing-5));
  }
`;
